import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  login: boolean = false;
  fullscreen: boolean = false;
  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.login = this.router.url === '/login' || this.router.url.includes('/sso-login');
        this.fullscreen = this.router.url === '/salon' || this.router.url === '/';
      }
    });
  }
}
